import _ from 'lodash';
import CookieDough from 'cookie-dough';
import createHmac from 'create-hmac';

const DEFAULT_BASE_URL = '/api';
const OneDay = 86400; // s
const OneYear = OneDay * 365;

let env = (typeof window !== 'undefined' ? window.ENV : (process.env.NODE_ENV || 'development'));
// TODO: Set expires
let cookieOptions = {
  path: '/',
  secure: env === 'staging' || env === 'production',
  maxAge: OneYear };

class DelectoryApi {
  constructor(opts) {
    opts = _.defaults(opts, {baseUrl: DEFAULT_BASE_URL});

    this.baseUrl = opts.baseUrl;
    this._req = opts.req; // accessible server-side only

    this._prepResources();

    this.signPayload = (payload) => payload; // NOOP
    if(typeof window === 'undefined' && opts.apiKey && opts.apiSecret) {
      this._apiKey = opts.apiKey;
      this._apiSecret = opts.apiSecret;

      this.signPayload = (requestPayload) => {
        requestPayload.key = this._apiKey;
        requestPayload.signature = createHmac('sha256', this._apiSecret).update(JSON.stringify(requestPayload.payload)).digest('base64');
        return requestPayload;
      };
    }
    else {
      this.setAuthCredentials({
        session_key: opts.sessionKey || null,
        session_token: opts.sessionToken || null,
        dismiss_cookies: opts.dismissCookies || false
      });
    }
  }

  getAuthCredentials() {
    return {
      session_key: this._session_key,
      session_token: this._session_token
    };
  }

  setCookiesDismissed(payload) {
    this._dismiss_cookies = payload.dismiss_cookies;

    if(payload.dismiss_cookies) {
      let cookie = CookieDough(this._req);
      cookie.set('dismiss_cookies', payload.dismiss_cookies);
    }
  }

  setAuthCredentials(payload) {
    this._session_key = payload.session_key;
    this._session_token = payload.session_token;
    if (payload.dismiss_cookies) {
      this._dismiss_cookies = payload.dismiss_cookies;
    }

    if(payload.session_key && payload.session_token) {
      let cookie = CookieDough(this._req);
      cookie.set('banquet_st', payload.session_token, cookieOptions);
      cookie.set('banquet_sk', payload.session_key, cookieOptions);
    }

    if(payload.dismiss_cookies) {
      let cookie = CookieDough(this._req);
      cookie.set('dismiss_cookies', payload.dismiss_cookies);
    }
  }

  _prepResources() {
    let resources = {
      Bookmarks         : require('./resources/Bookmarks'),
      Collections       : require('./resources/Collections'),
      Customers         : require('./resources/Customers'),
      InventoryRecords  : require('./resources/InventoryRecords'),
      Exports           : require('./resources/Exports'),
      Orders            : require('./resources/Orders'),
      ShoppingCarts     : require('./resources/ShoppingCarts'),
      Stores            : require('./resources/Stores'),
      Sitemaps          : require('./resources/Sitemaps'),
      SmartLinks        : require('./resources/SmartLinks'),
      Domains           : require('./resources/Domains'),
      WineSkus          : require('./resources/WineSkus')
    };
    for(let resourceName in resources) {
      this[resourceName[0].toLowerCase() + resourceName.substring(1)] = new resources[resourceName](this);
    }
  }
}

export default DelectoryApi;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/lib/delectory.js